module.exports = __webpack_public_path__ + "static/img/b4.95a50d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/b4.png
// module id = +lJL
// module chunks = 0